module.exports = __webpack_public_path__ + "static/media/item_12_1_comp.8bdf9534.png";